import { createSlice } from "@reduxjs/toolkit";

const upsertParticipant = (state, { payload }) => {
  if (!payload?.userId) return;
  const participant = state.participants.find(
    (p) => p.userId === payload.userId,
  );
  if (participant) Object.assign(participant, payload);
  else state.participants.push(payload);
};

const videoCallSlice = createSlice({
  name: "videoCall",
  initialState: { participants: [] },
  reducers: {
    addParticipant: upsertParticipant,
    updateParticipant: upsertParticipant,
    removeParticipant: (state, { payload }) => {
      state.participants = state.participants.filter(
        (p) => p.userId !== payload,
      );
    },
    resetParticipants: (state) => {
      state.participants = [];
    },
  },
});

export const {
  addParticipant,
  removeParticipant,
  updateParticipant,
  resetParticipants,
} = videoCallSlice.actions;
export default videoCallSlice.reducer;
